<template>
    <div>
        <div v-if="row.status === 2 || row.status === 0 || row.status === 1">
            <el-link v-pageBtn-lbl="'cancel'" :underline="false" type="text" class="clgl-sendcar" @click="cancelCar">取消</el-link>
        </div>
        <div v-else-if="row.status === 4 || row.status === 5 || row.status === 9">
            <el-link v-pageBtn-lbl="'del'" :underline="false" type="text" class="clgl-sendcar" @click="delCar">删除</el-link>
        </div>
        <div v-else>
            <el-link v-pageBtn-lbl="'look'" :underline="false" type="text" class="clgl-sendcar" @click="showForm">查看</el-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        column: { type: Object, default: null },
        row: { type: Object, default: null },
        index: { type: Number, default: null }
    },
    data() {
        return {
            editBtn: false
        }
    },
    watch: {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        // 查看
        showForm() {
            const _this = this.$vnode.context.$vnode.context
            _this.moduleInfo.sendcar = []
            this.$vnode.context.$parent.formTitle = this.$tx('clgl.tjbb.DisDetai', '派车详情')
            this.$vnode.context.$parent.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: 'default'
                }
            ]
            this.$bus.emit('openBusiform', _this.moduleInfo, this.row, 0)
        },
        // 取消
        cancelCar() {
            var _this = this
            this.$confirm(this.$tx('clgl.pcgl.cancelCar', '确定要取消派车吗？'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                .then(() => {
                    _this.row.status = 9
                    _this
                        .$http({
                            method: 'PUT',
                            url: 'clgl/sendcar/update',
                            data: _this.row
                        })
                        .then((res) => {
                            if (res.code === 'success') {
                                // _this.$toast.success(res.message)
                                // _this.$bus.emit('refreshListData')
                                // 调用接口
                                _this
                                    .$http({
                                        method: 'POST',
                                        url: 'clgl/ycsq/cancelYcsq',
                                        data: _this.row
                                    })
                                    .then((res) => {
                                        if (res.code === 'success') {
                                            _this.$toast.success(res.message)
                                            _this.$bus.emit('refreshListData')
                                        } else {
                                            _this.$toast.fail(res.message)
                                        }
                                    })
                            } else {
                                _this.$toast.fail(res.message)
                            }
                        })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        /**
         * 拒绝派车
         */
        delCar() {
            var _this = this
            this.$confirm(this.$tx('clgl.tjbb.isDelete', '确定要删除该条数据吗？'), this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                .then(() => {
                    this.$http({
                        method: 'DELETE',
                        url: 'clgl/sendcar/delete',
                        params: {
                            ids: _this.row.id
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            this.$bus.emit('refreshListData')
                        } else {
                            this.$message.fail(res.message)
                        }
                    })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        }
    }
}
</script>

<style scoped lang="scss">
.pcgl-btn {
    display: flex;
    justify-content: space-between;
}
.pcgl-btn .el-button {
    padding: 0px 7px;
}
.clgl-sendcar {
    color: #333;
    font-weight: normal;
}
.clgl-sendcar:hover {
    color: #409eff;
}
</style>
